import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { RU_APOSTILLE } from "@/data/ru-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ru/apostille";
const C = RU_APOSTILLE;

export const Route = createFileRoute("/ru/apostille")({
  head: () => ({
    meta: [
      { title: ctaTitle("Апостиль в Таиланде — оформление через МИД | NYC Legal", "/ru/apostille", "th")},
      { name: "description", content: ctaDesc("Апостиль МИД Таиланда (Гаагская конвенция) за 5–7 рабочих дней. Сертифицированный перевод RU↔TH. Send your documents for a free eligibility check.", "/ru/apostille", "th")},
      { property: "og:title", content: ctaTitle("Апостиль в Таиланде | NYC Legal", "/ru/apostille", "th")},
      { property: "og:description", content: ctaDesc("Двусторонний апостиль RU↔TH. Нотариус, перевод, МИД, Посольство РФ — под одной крышей.", "/ru/apostille", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ru_RU" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/apostille" },
          { hreflang: "en", path: "/en/apostille" },
          { hreflang: "zh", path: "/zh/apostille" },
          { hreflang: "ja", path: "/ja/apostille" },
          { hreflang: "ko", path: "/ko/apostille" },
          { hreflang: "ru", path: "/ru/apostille" },
          { hreflang: "x-default", path: "/apostille" },
        ],
        "/apostille",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Apostille (RU)", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "RU"], inLanguage: "ru",
        priceRange: "฿1,500–฿5,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ru",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "HowTo", inLanguage: "ru",
        name: C.stepsH2, step: C.steps.map((s, i) => ({
          "@type": "HowToStep", position: i + 1, name: s.name, text: s.text })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Главная", item: `${SEO_SITE}/ru` },
          { "@type": "ListItem", position: 2, name: "Апостиль", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
